import { AppConstants, isProductionHost } from '..';

const getPathHelpUrl = (path: string) => {
  const pathUrl = isProductionHost()
    ? AppConstants.PATH_HELP_PRODUCTION : AppConstants.PATH_HELP_QA;

  return pathUrl.replace(AppConstants.PATH_PLACEHOLDER, path);
};

const getGUIDHelpUrl = (guid: string) => getPathHelpUrl(`${AppConstants.GUID_POSTFIX}${guid}`);

export const getHelpUrl = (helpID: string) => {
  if (!helpID) {
    return null;
  }

  // Hard-coded url:
  if (helpID.startsWith(AppConstants.URL_PREFIX)) {
    return helpID.substring(AppConstants.URL_PREFIX.length);
  }

  // Prod or QA url:
  if (helpID.includes(AppConstants.PATH)) {
    return getPathHelpUrl(helpID.substring(AppConstants.PATH.length));
  }

  // GUID-based url:
  let id = helpID;
  if (helpID.includes(AppConstants.HELP_ID_DELIMITER)) {
    [, id] = helpID.split(AppConstants.HELP_ID_DELIMITER);
  }
  id = AppConstants.GUID_PREFIX + id;
  return getGUIDHelpUrl(id);
};

export const replaceDocLinks = (text: string, startingIndex: number): string => {
  const prefixIndex = text.indexOf(AppConstants.HELP_ID_PREFIX, startingIndex);
  if (prefixIndex === -1) {
    return text;
  }
  const suffixIndex = text.indexOf(AppConstants.HELP_ID_SUFFIX, prefixIndex);
  if (suffixIndex === -1) {
    return text;
  }

  const paramText = text.substring(prefixIndex, suffixIndex + 1);

  const helpID = paramText.substring(
    AppConstants.HELP_ID_PREFIX.length,
    paramText.length - AppConstants.HELP_ID_SUFFIX.length,
  );

  const helpIdUrl = getHelpUrl(helpID.trim());

  const defaultIfNull = helpIdUrl !== null ? helpIdUrl : AppConstants.EMPTY_STRING;
  const replacedText = text.replace(paramText, defaultIfNull);

  return replaceDocLinks(replacedText, suffixIndex);
};
